import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './MentorPhotosSubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function MentorPhotosSubTab() {
  const [photos, setPhotos] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterMentorId, setFilterMentorId] = useState('');

  useEffect(() => {
    fetchProfiles();
  }, []);

  useEffect(() => {
    fetchPhotos();
  }, [filterMentorId]);

  const fetchProfiles = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/mentor-profiles`);
      setProfiles(response.data);
    } catch (err) {
      console.error('Failed to load profiles', err);
    }
  };

  const fetchPhotos = async () => {
    try {
      setLoading(true);
      const url = filterMentorId
        ? `${API_URL}/api/mentor-photos?mentor_id=${encodeURIComponent(filterMentorId)}`
        : `${API_URL}/api/mentor-photos`;
      const response = await axios.get(url);
      setPhotos(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке фото: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Удалить эту запись о фото?')) {
      try {
        await axios.delete(`${API_URL}/api/mentor-photos/${id}`);
        fetchPhotos();
      } catch (err) {
        setError('Ошибка при удалении: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  const mentorLabel = (mentorId) => {
    const p = profiles.find((x) => x.id === mentorId);
    if (!p) return `ID ${mentorId}`;
    return `${p.first_name} ${p.last_name || ''} (${p.login})`.trim();
  };

  if (loading && photos.length === 0) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="mentor-photos-sub-tab">
      <div className="tab-header">
        <h2>Фотографии менторов</h2>
        <div className="filter-row">
          <label htmlFor="filter_mentor">Ментор:</label>
          <select
            id="filter_mentor"
            value={filterMentorId}
            onChange={(e) => setFilterMentorId(e.target.value)}
            className="filter-select"
          >
            <option value="">Все</option>
            {profiles.map((p) => (
              <option key={p.id} value={p.id}>
                {p.first_name} {p.last_name || ''} ({p.login})
              </option>
            ))}
          </select>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      <p className="hint">Добавление фото возможно только через заявку на верификацию (вкладка «Заявки на верификацию»). Здесь можно только просматривать и удалять записи.</p>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Ментор</th>
              <th>Ссылка на фото</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {photos.length === 0 ? (
              <tr>
                <td colSpan="4" className="empty-state">
                  Нет фотографий. Они появляются при создании заявки на верификацию.
                </td>
              </tr>
            ) : (
              photos.map((ph) => (
                <tr key={ph.id}>
                  <td>{ph.id}</td>
                  <td>{mentorLabel(ph.mentor_id)}</td>
                  <td>
                    <a href={ph.s3_url} target="_blank" rel="noopener noreferrer">
                      {ph.s3_url.length > 60 ? ph.s3_url.substring(0, 60) + '...' : ph.s3_url}
                    </a>
                  </td>
                  <td>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(ph.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MentorPhotosSubTab;
